import 'source-map-support/register';

import { merge } from 'roc';
import { baseConfig as baseConfigRocWeb, metaConfig as metaConfigRocWeb } from 'roc-web';

/**
 * Gives the base configuration.
 *
 * @returns {object} Returns the base configuration
 */
export const baseConfig = merge(baseConfigRocWeb, require('../config/roc.config.js'));

/**
 * Gives the meta configuration.
 *
 * @returns {object} Returns the meta configuration
 */
export const metaConfig = merge(metaConfigRocWeb, require('../config/roc.config.meta.js'));
